export default __webpack_public_path__ + "static/media/noticebard.5dcdbbb6.jpeg";